import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class IndexRoute extends Route {
  @service router;
  async beforeModel() {
    this.router.transitionTo('settings.account');
  }
}

export default instrumentRoutePerformance(IndexRoute);
